export default __webpack_public_path__ + "media/images/favicon-96x96-2421d032.png";